var map = {
	"./FaIcon.vue": "8588",
	"./LangSwitcher.vue": "cd13",
	"./LoginPage.vue": "5de4",
	"./NavigationMenu.vue": "672e",
	"./Notify.vue": "ac4f",
	"./PaymentSystem.vue": "c372"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1fbd";